export default function (state, getters, rootState, rootGetters) {
    return rootState.finances.payments.form.data_report;
}